import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Login } from "./login";
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { LoaderService } from "../../LoaderService";
declare var $: any;

@Component({
  selector: '[mft-identitylogout]',
  templateUrl: './identitylogout.component.html'
})
export class IdentityLogoutComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    private router: Router,
    public globalService: GlobalService,
    public loaderService: LoaderService
  ) { }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  public logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/login/identitylogout.component.ts